import React, {Component} from 'react'
import TextField from '@material-ui/core/TextField';

class ContactForm extends Component {

    state = {
        email: '',
        name: '',
        telephone: '',
        text: ''
    }

    render() {
        const estate = this.props.estate;
        return (
            <div className="sidebar-widget popular-posts agent-contact">
                <div className="main-title-2">
                    <h1><span>Agent </span>de contact</h1>
                </div>
                <div className="row agent-contact-header">
                    <div className="col-md-6 col-lg-4 justify-content-center">
                        <img style={{ maxWidth: '100%' }} className='img-fluid' src={estate.photo_negociateur ? window.proxyUrl + estate.photo_negociateur._cdata : ''} alt="le négociateur"/>
                    </div>
                    <div className="col-md-6 col-lg-8">
                        <div className="property-agent">
                            <h4 className="title-agent">{estate.negociateur ? estate.negociateur._cdata.trim() : ''}</h4>
                            <ul className="list-unstyled">
                                <li className="d-flex justify-content-between">
                                    <strong>Mobile: </strong>
                                    <span className="color-text-a">{estate.tel_negociateur ? estate.tel_negociateur._cdata : '-'}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row contact-form">
                    <form action="">
                        <TextField
                            id="user-name"
                            placeholder="Votre nom"
                            className="form-field name"
                            value={this.state.name}
                            onChange={(e) => this.setState({...this.state, name:e.target.value})}
                            margin="normal"
                            name="Nom"
                        />
                        <TextField
                            id="user-telephone"
                            placeholder="Téléphone"
                            className="form-field telephone"
                            value={this.state.telephone}
                            onChange={(e) => this.setState({...this.state, telephone:e.target.value})}
                            margin="normal"
                            name="Téléphone"
                        />
                        <TextField
                            id="user-email"
                            placeholder="Email"
                            className="form-field email"
                            value={this.state.email}
                            onChange={(e) => this.setState({...this.state, email:e.target.value})}
                            margin="normal"
                            name="E-mail"
                        />
                        <TextField
                            id="user-text"
                            placeholder={estate.titre ? "Bonjour, je suisse intéressé par "+estate.titre._cdata.trim() : "-"}
                            className="form-field text"
                            value={this.state.text}
                            onChange={(e) => this.setState({...this.state, text:e.target.value})}
                            margin="normal"
                            multiline
                            name="Message"
                        />
                        <button className="button-theme contact-btn">Demande d'info</button>
                    </form>
                </div>
            </div>
        )
    }
}

export default ContactForm;
